module.exports = __webpack_public_path__ + "img/close.27cdd4b0.svg";